

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class PartnersReferralCodesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'partners-referral-codes';
        this.Server = this.props.context.getState().server.partnersReferralCodes;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'code'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'userId',
                label: 'user',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'user',
                show: 'email'
            },
            {
                id: 'code',
                label: 'code',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'dateDisabled',
                label: 'dateDisabled',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}